<template>
    <div v-if="!!forum" class="class-page topic-page">
        <!-- Header -->
        <class-page-header :details="details" :current-section="parseInt(sectionId)" :course="course" :menu="menu" :is-class-item-page="true" :course-content="courseContent"></class-page-header>

				<h2>{{forum.TITLE}}</h2>
				<!-- New button -->
				<div class="text-right mb-1em" v-if="!!forum.TOPICS && forum.TOPICS.length && forum.STUDENTS_CREATE_TOPIC_FLG === 'Y'">
						<button type="button" class="btn btn-new" :fields="{}" data-toggle="modal" data-target="#addNewModal" @click="addTopic">
								<i class="fa fa-plus-circle"></i>
								{{ $t("MAIN_CONTENT.Forum.newTopic") }}
						</button>
				</div>

				<div v-if="!!forum.TOPICS && !forum.TOPICS.length" style="margin-top: 25px; margin-bottom: 25px; padding:35px; border-radius: 5px; border: 3px dashed #CCC;">
					<h2>
						{{ $t("MAIN_CONTENT.Forum.noTopicsMessage") }}
						<button type="button" class="btn btn-new" :fields="{}" data-toggle="modal" data-target="#addNewModal" @click="addTopic" v-if="forum.STUDENTS_CREATE_TOPIC_FLG === 'Y'">
								<i class="fa fa-plus-circle"></i>
								{{ $t("MAIN_CONTENT.Forum.newTopic") }}
						</button>
					</h2>
				</div>
				<!-- Topics -->
				<div class="topic-box topics" v-for="( topic, index ) in forum.TOPICS" :key="topic.TOPIC_ID">
						<div class="row">
							<img :src="topic.POSTER_PHOTO_URL"
										alt="Photo"
										class="col-xs-3 col-md-2 img-responsive rounded cp-student-photo-image-circle"
										v-if="topic.POSTER_PHOTO_URL" />
							<img src="/CommunityWebPortal/_app/includes/static/images/profiles/no-staff-image.png"
										class="col-xs-3 col-md-2 img-responsive cp-student-photo-image-circle"
										alt="Photo"
										v-else />
							<div class="col-md-10">
									<strong v-if="!!topic.USER_NAME">
										{{ $t('MAIN_CONTENT.Forum.topicHeader', { label: topic.USER_NAME } ) }}
									</strong>
									<strong v-else-if="!!topic.MODIFIED_BY">
										{{ $t('MAIN_CONTENT.Forum.topicHeader', { label: topic.MODIFIED_BY } ) }}
									</strong>
									<strong v-else>
										{{ $t('MAIN_CONTENT.Forum.topicHeader', { label: topic.CREATED_BY } ) }}
									</strong>
									<p>
										<span v-if="topic.NEW_POSTS_FLG === 'Y'" class="badge badge-pill bg-teal">
											{{ $t("MAIN_CONTENT.commonContent.newPosts") }}
										</span>
										<a href="javascript:void(0)" @click.prevent="goToPosts(topic.TOPIC_ID)">
											<strong>{{ topic.TITLE }}</strong>
										</a>
									</p>
									<p>{{ topic.SUBJECT }}</p>
									<div class="topic-preview" v-html="topic.MESSAGE"></div>
							</div>
						</div>

						<!-- Buttons -->
						<div class="row actions">
								<!-- Edit -->
								<a :href="`/edit/${ topic.TOPIC_ID }`" class="btn on-grey" v-if="selectedStudent.STUDENT_RID === topic.CREATED_BY" @click.prevent="editTopic(topic)">
										<strong><i class="fa fa-pen"></i> {{ $t("commonText.edit") }}</strong>
								</a>

								<!-- Posts -->
								<a @click="goToPosts(topic.TOPIC_ID)" class="btn posts-comments-btn">
										<i class="fa fa-comments on-teal"></i>
										<span class="badge badge-pill bg-teal">
											{{ topic.NUMBER_OF_REPLIES ? topic.NUMBER_OF_REPLIES - 1 : 0 }}
										</span>
								</a>
						</div>
				</div>

				<!-- Create Topic modal -->
				<modal mode="custom" :modal-title="$t('MAIN_CONTENT.Forum.newTopic')" :show="showNewTopicModal" dialog-size="lg" name="newTopicModal" @close="showNewTopicModal = false" v-if="!!forum">
					<template>
						<!-- Title -->
						<div class="form-group">
								<label for="title">{{ $t("commonText.title") }}</label>
								<input class="form-control" id="title" v-model.trim="topic.TITLE" :placeholder="$t('commonText.title')" />
						</div>

						<!-- Message -->
						<div class="form-group">
								<label for="message">{{ $t("MAIN_CONTENT.Forum.message") }}</label>
								<ckeditor4 
									v-model="topic.MESSAGE" 
									:config="editorConfig"
									:simpleImagesDialog="true"
									id="message"
								>
								</ckeditor4>
						</div>
					</template>
					<template slot="footer">
						<button type="button" class="btn btn-default" @click="showNewTopicModal = false">
							{{ $t('commonText.cancel') }}
						</button>
						<button type="button" class="btn btn-new" @click="createTopic">
							{{ $t("MAIN_CONTENT.commonContent.submit") }}
						</button>
					</template>
				</modal>
				<!-- Update Topic modal -->
				<modal mode="custom"
							 :modal-title="$t('MAIN_CONTENT.Forum.editTopic')"
							 :show="showEditTopicModal"
							 dialog-size="lg"
							 name="editTopicModal"
							 @close="showEditTopicModal = false"
							 v-if="!!forum">
					<template>
						<!-- Title -->
						<div class="form-group">
								<label for="title">{{ $t("commonText.title") }}</label>
								<input class="form-control" id="title" v-model.trim="topic.TITLE" :placeholder="$t('commonText.title')" />
						</div>

						<!-- Message -->
						<div class="form-group">
								<label for="message">
									{{ $t("MAIN_CONTENT.Forum.message") }}
								</label>
								<ckeditor4 
									v-model="topic.MESSAGE" 
									:config="editorConfig"
									:simpleImagesDialog="true"
									id="message"
								>
								</ckeditor4>
						</div>
					</template>
					<template slot="footer">
						<button type="button" class="btn btn-default" @click="showEditTopicModal = false">
							{{ $t('MAIN_CONTENT.commonContent.closeButton') }}
						</button>
						<button type="button" class="btn btn-new" @click="updateTopic(topic)">
							{{ $t('commonText.save') }}
						</button>
					</template>
				</modal>
				<class-page-footer :course="course" :menu="menu" :current-section="parseInt(sectionId)" :is-class-item-page="true" :course-content="courseContent"/>
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

import ClassPageHeader from "./Header.vue";
import ClassPageFooter from "./Footer.vue";

import ClassPageHomeResource from '../../api/ClassPageHome';
import ClassPageDetailsResource from '../../api/ClassPageDetails';
import ClassPageMenuResource from '../../api/ClassPageMenu';
import CoursesResource from '../../api/Courses';
import ForumResource from '../../api/ClassPageForum';
import TopicResource from '../../api/ClassPageTopic';

import Modal from 'COMMONS/shared/Modal/Modal.vue';

import ckeditor4 from '../ckeditor4.vue';

export default {
		name: "Forum",
		data: () => (
				{	
					showNewTopicModal: false,
					showEditTopicModal: false,
					forum: {},
					menu: [],
					details: {},
					course: {},
					courseContent: {},
					topic: {
						TITLE  	: "",
						SUBJECT	: "",
						MESSAGE	: ""
					},
					topics: [],
					editorConfig: {
						'language': 'en',
						'uicolor':'#AADC6E',
						'customConfig':'',
						'toolbarCanCollapse': true,
						'toolbarStartupExpanded' : true,
						'enableTabKeyTools':true,
						'forcePasteAsPlainText':false,
						'forcePasteFromWord':true,
						'ignoreEmptyParagraph':true,
						'pasteFromWordPromptCleanup':true,
						'pasteFromWordIgnoreFontFace':true,
						'pasteFromWordKeepsStructure':true,
						'pasteFromWordRemoveFontStyles':true,
						'pasteFromWordRemoveStyles':true,
						'contentsCssStatic':"",
						'removePlugins': { 
							/* set to 1 to remove the plugin, 0 to keep it */
							"forms":1, 
							"print":1,
							"preview":1,
							"about":1,
							"flash":1, 
							"newpage":1,
							"eqneditor":1,
							"justify":1,
							"colorbutton":1,
							"wsc":1,
							"scayt":1,
							"link":1,
							"a11yhelp":1,
							"video":1,
							"tabletools":1,
							"table":1,
							"iframe":1,
							"div":1,
							"sourcearea":1,
							"templates":1,
							"smiley":1,
							"about":1,
							"pagebreak":1,
							"find":1
						},
						'extraPlugins' : {"image":1,"justify":1,"colorbutton":1, "find":1, "font":1},
						'tabSpaces':5,
						'fontSize_sizes':'8/8pt;9/9pt;10/10pt;11/11pt;12/12pt;14/14pt;16/16pt;18/18pt;20/20pt;22/22pt;24/24pt;26/26pt;28/28pt;30/30pt;36/36pt;48/48pt',
						'font_names':
							'Andale Mono/Andale Mono, monospace;'+
							'Arial/Arial, Helvetica, sans-serif;'+
							'Bitstream Vera Sans/Bitstream Vera Sans, Helvetica, sans-serif;' +
							'Bitstream Vera Serif/Bitstream Vera Serif, Times New Roman, serif;' +
							'Comic Sans MS/Comic Sans MS, cursive;' +
							'Courier New/Courier New, Courier, monospace;' +
							'Gentium Basic/Gentium Basic, Times New Roman, serif;' +
							'Gentium Book Basic/Gentium Book Basic, Times New Roman, serif;' +
							'Georgia/Georgia, serif;' +
							'Impact/Impact, serif;' +
							'Liberation Mono/Liberation Mono, Courier New, Courier, monospace;' +
							'Liberation Sans/Liberation Sans, Helvetica, sans-serif;' +
							'Liberation Serif/Liberation Serif, Times New Roman, serif;' +
							'Linux Libertine/Linux Libertine, Helvetica, sans-serif;' +
							'Souvenir Mono ITCTT/Souvenir Mono ITCTT, Courier New, Courier, monospace;' +
							'Synchro LET/Synchro LET, sans-serif;' +
							'Tahoma/Tahoma, Geneva, sans-serif;' +
							'Times New Roman/Times New Roman, Times, serif;' +
							'Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;' +
							'Verdana/Verdana, Geneva, sans-serif'
					}
				}
		),
		components: { 
			ClassPageHeader,
			ClassPageFooter,
			Modal,
			ckeditor4,
		},
		computed: {
			...mapGetters( [ "selectedStudent" ] ),
			sectionId() {
				return this.$route.params.folderId ? this.$route.params.folderId : 0;
			},
			forumType(){
				let type = '';
				if( this.$route.name === 'ClassPageForum' ){
					type = 'course';
				} else if( this.$route.name === 'ClassPageSectionForum' ){
					type = 'course';
				} else if ( this.$route.name === 'ClassPageGroupForum' ) {
					type = 'group';
				} else if ( this.$route.name === 'ClassPageStudentForum' ) {
					type = 'student';
				}

				return type;
			}
		},

		methods: {
			goToPosts(topicId) {
				let name = '';
				let params = this.$route.params;
				params.topicId = topicId;

				if( this.$route.name === 'ClassPageForum' ){
					name = 'ClassPageForumPost';
				} else if( this.$route.name === 'ClassPageSectionForum' ){
					name = 'ClassPageSectionForumPost';
				} else if ( this.$route.name === 'ClassPageGroupForum' ) {
					name = 'ClassPageGroupForumPost';
				} else if ( this.$route.name === 'ClassPageStudentForum' ) {
					name = 'ClassPageStudentForumPost';
				}
				
				this.$router.push({ 
					name: name, 
					params: params,
				});
			},
			/**
				* Adds a new topic into the array
				*/
			fetchForum(){
				const Forum = new ForumResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
						forumId: this.$route.params.forumId,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
					type: this.forumType,
				});

				Forum.get().then(() => {
					this.forum = Forum.getResponseData();
				});
			},
		fetchMenu(){
			const ClassPageMenu = new ClassPageMenuResource({
				routeParams: {
					courseSectionGuid: this.$route.params.courseSectionGUID,
				},
				query: {
					student_rid: this.selectedStudent.STUDENT_RID,
				},
			});

			ClassPageMenu.get().then(()=>{
				this.menu = ClassPageMenu.getResponseData();
			});
		},
		fetchDetails(){
			const ClassPageDetails = new ClassPageDetailsResource({
				routeParams: {
					courseSectionGuid: this.$route.params.courseSectionGUID,
				},
				query: {
					student_rid: this.selectedStudent.STUDENT_RID,
				},
			});

			ClassPageDetails.get().then(()=>{
				this.details = ClassPageDetails.getResponseData();
			});
		},
		fetchCourse(){
			var Course = new CoursesResource({
				routeParams: {
					courseSectionGuid: this.$route.params.courseSectionGUID,
				},
				query: {
					student_rid: this.selectedStudent.STUDENT_RID,
				},
			});

			Course.get().then(()=>{
				this.course = Course.getResponseData();
			});
		},
		addTopic() {
			this.topic = {
					TITLE  	: "",
					SUBJECT	: "",
					MESSAGE	: ""
			};
			this.showNewTopicModal = true;
		},
		createTopic () {
			const Topic = new TopicResource({
				routeParams: {
					courseSectionGuid: this.$route.params.courseSectionGUID,
					forumId: this.$route.params.forumId,
				},
				query: {
					student_rid: this.selectedStudent.STUDENT_RID,
				},
				data: {
					"title": this.topic.TITLE,
					"message": this.topic.MESSAGE,
				},
				type: this.forumType,
			});

			Topic.post().then( () => {
				this.forum.TOPICS.push(Topic.getResponseData());
				this.goToPosts(Topic.getResponseData().TOPIC_ID);
			});

			this.topic = {
					TITLE  	: "",
					SUBJECT	: "",
					MESSAGE	: ""
			};
			
			this.showNewTopicModal = false;
		},
		editTopic( topic ){
			this.showEditTopicModal = true;
			this.topic = JSON.parse(JSON.stringify(topic));
		},
		updateTopic (topic) {
			const Topic = new TopicResource({
				routeParams: {
					courseSectionGuid: this.$route.params.courseSectionGUID,
					forumId: this.$route.params.forumId,
					topicId: topic.TOPIC_ID,
				},
				query: {
					student_rid: this.selectedStudent.STUDENT_RID,
				},
				data: {
					"title": this.topic.TITLE,
					"message": this.topic.MESSAGE,
				},
				type: this.forumType,
			});
			Topic.put().then( () => {
				let i = this.forum.TOPICS.findIndex( t => t.TOPIC_ID === topic.TOPIC_ID);
				this.$set( this.forum.TOPICS, i, Topic.getResponseData() );

			});

			this.topic = {
					TITLE  	: "",
					SUBJECT	: "",
					MESSAGE	: ""
			};
			
			this.showEditTopicModal = false;
		},
		fetchClassHome(){
			const ClassPageHome = new ClassPageHomeResource({
				routeParams: {
					courseSectionGuid: this.$route.params.courseSectionGUID,
				},
				query: {
					student_rid: this.selectedStudent.STUDENT_RID,
				},
			});

			ClassPageHome.get().then(()=>{
				this.courseContent = ClassPageHome.getResponseData().COURSE_CONTENT;
			});
		},
	},

	created () {
		this.$store.commit('setUseHeader', false);
		this.fetchMenu();
		this.fetchDetails();
		this.fetchCourse();
		this.fetchClassHome();
		this.fetchForum();
	}
};
</script>
